"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkDomain = exports.LinkDomains = exports.getDomain = exports.Domains = void 0;
const brand_1 = require("../brand");
const country_code_1 = require("../country-code");
const platform_1 = require("../platform");
var Domains;
(function (Domains) {
    Domains["BK_AE"] = "www.burgerking.ae";
    Domains["BK_AQ"] = "www.burgerking.io";
    Domains["BK_AR"] = "www.burgerking.com.ar";
    Domains["BK_AU"] = "www.hungryjacks.com.au";
    Domains["BK_AT"] = "www.burgerking.at";
    Domains["BK_BR"] = "www.burgerking.com.br";
    Domains["BK_CA"] = "www.burgerking.ca";
    Domains["BK_CH"] = "www.burger-king.ch";
    Domains["BK_CL"] = "www.burgerking.cl";
    Domains["BK_CZ"] = "www.burgerking.cz";
    Domains["BK_DE"] = "www.burgerking.de";
    Domains["BK_DO"] = "www.burgerking.com.do";
    Domains["BK_ES"] = "www.burgerking.es";
    Domains["BK_EG"] = "www.burgerking.com.eg";
    Domains["BK_GB"] = "www.burgerking.co.uk";
    Domains["BK_IE"] = "www.burgerking.ie";
    Domains["BK_KY"] = "www.burgerking.ky";
    Domains["BK_NL"] = "www.burgerking.nl";
    Domains["BK_NZ"] = "www.burgerking.co.nz";
    Domains["BK_MY"] = "www.burgerking.com.my";
    Domains["BK_MA"] = "www.burgerking.ma";
    Domains["BK_MU"] = "www.burgerking.mu";
    Domains["BK_MX"] = "www.burgerking.com.mx";
    Domains["BK_OM"] = "www.burgerking.co.om";
    Domains["BK_PL"] = "www.burgerking.pl";
    Domains["BK_PR"] = "www.burgerkingpr.com";
    Domains["BK_PT"] = "www.burgerking.pt";
    Domains["BK_PH"] = "www.burgerking.ph";
    Domains["BK_RO"] = "www.burgerking.ro";
    Domains["BK_SA"] = "www.burgerking.com.sa";
    Domains["BK"] = "www.bk.com";
    Domains["BK_ZA"] = "www.burgerking.co.za";
    Domains["LTW"] = "";
    Domains["PLK_AQ"] = "www.popeyeschicken.io";
    Domains["PLK_AU"] = "www.popeyeschicken.au";
    Domains["PLK_BH"] = "www.popeyes.bh";
    Domains["PLK_BR"] = "www.popeyesbrasil.com.br";
    Domains["PLK_CA"] = "www.popeyeschicken.ca";
    Domains["PLK_CH"] = "www.popeyeschicken.ch";
    Domains["PLK_CZ"] = "www.popeyeschicken.cz";
    Domains["PLK_ES"] = "www.popeyeschicken.es";
    Domains["PLK_FR"] = "www.popeyeschicken.fr";
    Domains["PLK_IT"] = "www.popeyes.it";
    Domains["PLK_KR"] = "www.popeyes.co.kr";
    Domains["PLK_KW"] = "www.popeyes.com.kw";
    Domains["PLK_NZ"] = "www.popeyeschicken.co.nz";
    Domains["PLK_PL"] = "www.popeyeschicken.pl";
    Domains["PLK_PT"] = "www.popeyeschicken.pt";
    Domains["PLK_RO"] = "www.popeyesromania.ro";
    Domains["PLK_SA"] = "www.popeyes.com.sa";
    Domains["PLK_SG"] = "www.popeyes.com.sg";
    Domains["PLK_TH"] = "www.popeyeschicken.th";
    Domains["PLK_TW"] = "www.popeyes.tw";
    Domains["PLK_QA"] = "www.popeyes.qa";
    Domains["PLK"] = "www.popeyes.com";
    Domains["TH_AQ"] = "www.timhortons.io";
    Domains["TH_CA"] = "www.timhortons.ca";
    Domains["TH_ES"] = "www.timhortons.es";
    Domains["TH_ID"] = "www.timhortons.id";
    Domains["TH_JP"] = "www.timhortons.jp";
    Domains["TH_KR"] = "www.timhortons.co.kr";
    Domains["TH_MY"] = "www.timhortons.my";
    Domains["TH_TW"] = "www.timhortons.tw";
    Domains["TH_US"] = "www.timhortons.com";
    Domains["FHS_AE"] = "www.firehousesubs.ae";
    Domains["FHS_AQ"] = "www.firehousesubs.io";
    Domains["FHS_CA"] = "www.firehousesubs.ca";
    Domains["FHS_CH"] = "www.firehousesubs.ch";
    Domains["FHS_MX"] = "www.firehousesubsmexico.com";
    Domains["FHS_SG"] = "www.firehousesubs.sg";
    Domains["FHS_GB"] = "www.firehousesubs.co.uk";
    Domains["FHS_US"] = "www.firehousesubs.com";
})(Domains = exports.Domains || (exports.Domains = {}));
/**
 * Return the production domain for the configured brand
 */
const getDomain = (brand, locale, platform) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    switch (brand) {
        case brand_1.Brand.BK:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.AE:
                    return Domains.BK_AE;
                case country_code_1.IsoCountryCode2Char.AR:
                    return Domains.BK_AR;
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.BK_AQ;
                case country_code_1.IsoCountryCode2Char.AU:
                    return Domains.BK_AU;
                case country_code_1.IsoCountryCode2Char.AT:
                    return Domains.BK_AT;
                case country_code_1.IsoCountryCode2Char.BR:
                    return Domains.BK_BR;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.BK_CA;
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.BK_CH;
                case country_code_1.IsoCountryCode2Char.CL:
                    return Domains.BK_CL;
                case country_code_1.IsoCountryCode2Char.CZ:
                    return Domains.BK_CZ;
                case country_code_1.IsoCountryCode2Char.DE:
                    return Domains.BK_DE;
                case country_code_1.IsoCountryCode2Char.DO:
                    return Domains.BK_DO;
                case country_code_1.IsoCountryCode2Char.ES:
                    return Domains.BK_ES;
                case country_code_1.IsoCountryCode2Char.EG:
                    return Domains.BK_EG;
                case country_code_1.IsoCountryCode2Char.GB:
                    return Domains.BK_GB;
                case country_code_1.IsoCountryCode2Char.IE:
                    return Domains.BK_IE;
                case country_code_1.IsoCountryCode2Char.KY:
                    return Domains.BK_KY;
                case country_code_1.IsoCountryCode2Char.MA:
                    return Domains.BK_MA;
                case country_code_1.IsoCountryCode2Char.MY:
                    return Domains.BK_MY;
                case country_code_1.IsoCountryCode2Char.MU:
                    return Domains.BK_MU;
                case country_code_1.IsoCountryCode2Char.MX:
                    return Domains.BK_MX;
                case country_code_1.IsoCountryCode2Char.NL:
                    return Domains.BK_NL;
                case country_code_1.IsoCountryCode2Char.NZ:
                    return Domains.BK_NZ;
                case country_code_1.IsoCountryCode2Char.OM:
                    return Domains.BK_OM;
                case country_code_1.IsoCountryCode2Char.PL:
                    return Domains.BK_PL;
                case country_code_1.IsoCountryCode2Char.PH:
                    return Domains.BK_PH;
                case country_code_1.IsoCountryCode2Char.PT:
                    return Domains.BK_PT;
                case country_code_1.IsoCountryCode2Char.PR:
                    return Domains.BK_PR;
                case country_code_1.IsoCountryCode2Char.RO:
                    return Domains.BK_RO;
                case country_code_1.IsoCountryCode2Char.SA:
                    return Domains.BK_SA;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.BK;
                case country_code_1.IsoCountryCode2Char.ZA:
                    return Domains.BK_ZA;
                default:
                    return Domains.BK;
            }
        case brand_1.Brand.LTW:
            return Domains.LTW;
        case brand_1.Brand.PLK:
            switch (locale.region) {
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.PLK_AQ;
                case country_code_1.IsoCountryCode2Char.AU:
                    return Domains.PLK_AU;
                case country_code_1.IsoCountryCode2Char.BH:
                    return Domains.PLK_BH;
                case country_code_1.IsoCountryCode2Char.BR:
                    return Domains.PLK_BR;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.PLK_CA;
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.PLK_CH;
                case country_code_1.IsoCountryCode2Char.CZ:
                    return Domains.PLK_CZ;
                case country_code_1.IsoCountryCode2Char.ES:
                    return Domains.PLK_ES;
                case country_code_1.IsoCountryCode2Char.FR:
                    return Domains.PLK_FR;
                case country_code_1.IsoCountryCode2Char.IT:
                    return Domains.PLK_IT;
                case country_code_1.IsoCountryCode2Char.KR:
                    return Domains.PLK_KR;
                case country_code_1.IsoCountryCode2Char.KW:
                    return Domains.PLK_KW;
                case country_code_1.IsoCountryCode2Char.NZ:
                    return Domains.PLK_NZ;
                case country_code_1.IsoCountryCode2Char.PL:
                    return Domains.PLK_PL;
                case country_code_1.IsoCountryCode2Char.PT:
                    return Domains.PLK_PT;
                case country_code_1.IsoCountryCode2Char.QA:
                    return Domains.PLK_QA;
                case country_code_1.IsoCountryCode2Char.RO:
                    return Domains.PLK_RO;
                case country_code_1.IsoCountryCode2Char.SA:
                    return Domains.PLK_SA;
                case country_code_1.IsoCountryCode2Char.SG:
                    return Domains.PLK_SG;
                case country_code_1.IsoCountryCode2Char.TW:
                    return Domains.PLK_TW;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.PLK;
                default:
                    return Domains.PLK;
            }
        case brand_1.Brand.TH:
            if (platform === platform_1.Platform.app) {
                return Domains.TH_CA;
            }
            switch (locale.region) {
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.TH_AQ;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.TH_CA;
                case country_code_1.IsoCountryCode2Char.ES:
                    return Domains.TH_ES;
                case country_code_1.IsoCountryCode2Char.KR:
                    return Domains.TH_KR;
                case country_code_1.IsoCountryCode2Char.MY:
                    return Domains.TH_MY;
                case country_code_1.IsoCountryCode2Char.TW:
                    return Domains.TH_TW;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.TH_US;
                default:
                    return Domains.TH_CA;
            }
        case brand_1.Brand.FHS:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.AE:
                    return Domains.FHS_AE;
                case country_code_1.IsoCountryCode2Char.AQ:
                    return Domains.FHS_AQ;
                case country_code_1.IsoCountryCode2Char.CA:
                    return Domains.FHS_CA;
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.FHS_CH;
                case country_code_1.IsoCountryCode2Char.MX:
                    return Domains.FHS_MX;
                case country_code_1.IsoCountryCode2Char.SG:
                    return Domains.FHS_SG;
                case country_code_1.IsoCountryCode2Char.US:
                    return Domains.FHS_US;
                case country_code_1.IsoCountryCode2Char.GB:
                    return Domains.FHS_GB;
                default:
                    return Domains.FHS_US;
            }
        default:
            return Domains.PLK;
    }
};
exports.getDomain = getDomain;
var LinkDomains;
(function (LinkDomains) {
    LinkDomains["BK_AQ"] = "";
    LinkDomains["BK_AR"] = "";
    LinkDomains["BK_AT"] = "";
    LinkDomains["BK_BR"] = "";
    LinkDomains["BK_CA"] = "";
    LinkDomains["BK_CH"] = "burgerkingch.app.link";
    LinkDomains["BK_CL"] = "";
    LinkDomains["BK_CZ"] = "";
    LinkDomains["BK_DE"] = "burgerkingde.app.link";
    LinkDomains["BK_ES"] = "";
    LinkDomains["BK_GB"] = "burgerkinguk.app.link";
    LinkDomains["BK_MX"] = "";
    LinkDomains["BK_NL"] = "";
    LinkDomains["BK_NZ"] = "";
    LinkDomains["BK_PL"] = "";
    LinkDomains["BK_PT"] = "";
    LinkDomains["BK_PR"] = "";
    LinkDomains["BK_RO"] = "";
    LinkDomains["BK_SA"] = "";
    LinkDomains["BK_US"] = "";
    LinkDomains["BK_ZA"] = "bksouthafrica.app.link";
    LinkDomains["LTW_US"] = "";
    LinkDomains["PLK_AQ"] = "";
    LinkDomains["PLK_CA"] = "";
    LinkDomains["PLK_CH"] = "";
    LinkDomains["PLK_CZ"] = "";
    LinkDomains["PLK_ES"] = "";
    LinkDomains["PLK_FR"] = "";
    LinkDomains["PLK_KR"] = "";
    LinkDomains["PLK_BR"] = "";
    LinkDomains["PLK_NZ"] = "";
    LinkDomains["PLK_PL"] = "";
    LinkDomains["PLK_PT"] = "";
    LinkDomains["PLK_SG"] = "";
    LinkDomains["PLK_TH"] = "";
    LinkDomains["PLK_TW"] = "";
    LinkDomains["PLK_US"] = "";
    LinkDomains["TH_AQ"] = "";
    LinkDomains["TH_CA"] = "";
    LinkDomains["TH_ES"] = "";
    LinkDomains["TH_ID"] = "";
    LinkDomains["TH_JP"] = "";
    LinkDomains["TH_KR"] = "";
    LinkDomains["TH_MY"] = "";
    LinkDomains["TH_TW"] = "";
    LinkDomains["TH_US"] = "";
    LinkDomains["FHS_AQ"] = "";
    LinkDomains["FHS_CA"] = "";
    LinkDomains["FHS_CH"] = "";
    LinkDomains["FHS_MX"] = "";
    LinkDomains["FHS_US"] = "";
    LinkDomains["BK_DEFAULT"] = "";
    LinkDomains["DEFAULT"] = "";
})(LinkDomains = exports.LinkDomains || (exports.LinkDomains = {}));
/**
 * Return the production link domain for the configured brand
 */
const getLinkDomain = (brand, locale) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    switch (brand) {
        case brand_1.Brand.BK:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.AQ:
                    return LinkDomains.BK_AQ;
                case country_code_1.IsoCountryCode2Char.AR:
                    return LinkDomains.BK_AR;
                case country_code_1.IsoCountryCode2Char.AT:
                    return LinkDomains.BK_AT;
                case country_code_1.IsoCountryCode2Char.BR:
                    return LinkDomains.BK_BR;
                case country_code_1.IsoCountryCode2Char.CA:
                    return LinkDomains.BK_CA;
                case country_code_1.IsoCountryCode2Char.CH:
                    return LinkDomains.BK_CH;
                case country_code_1.IsoCountryCode2Char.CL:
                    return LinkDomains.BK_CL;
                case country_code_1.IsoCountryCode2Char.CZ:
                    return LinkDomains.BK_CZ;
                case country_code_1.IsoCountryCode2Char.DE:
                    return LinkDomains.BK_DE;
                case country_code_1.IsoCountryCode2Char.ES:
                    return LinkDomains.BK_ES;
                case country_code_1.IsoCountryCode2Char.GB:
                    return LinkDomains.BK_GB;
                case country_code_1.IsoCountryCode2Char.MX:
                    return LinkDomains.BK_MX;
                case country_code_1.IsoCountryCode2Char.NL:
                    return LinkDomains.BK_NL;
                case country_code_1.IsoCountryCode2Char.NZ:
                    return LinkDomains.BK_NZ;
                case country_code_1.IsoCountryCode2Char.PL:
                    return LinkDomains.BK_PL;
                case country_code_1.IsoCountryCode2Char.PR:
                    return LinkDomains.BK_PR;
                case country_code_1.IsoCountryCode2Char.PT:
                    return LinkDomains.BK_PT;
                case country_code_1.IsoCountryCode2Char.RO:
                    return LinkDomains.BK_RO;
                case country_code_1.IsoCountryCode2Char.SA:
                    return LinkDomains.BK_SA;
                case country_code_1.IsoCountryCode2Char.US:
                    return LinkDomains.BK_US;
                case country_code_1.IsoCountryCode2Char.ZA:
                    return LinkDomains.BK_ZA;
                default:
                    return LinkDomains.BK_DEFAULT;
            }
        default:
            return LinkDomains.DEFAULT;
    }
};
exports.getLinkDomain = getLinkDomain;
//# sourceMappingURL=domains.js.map